export default "__VITE_ASSET__BawR8Y89__"